import { create } from 'zustand';

// Espacio compartido activo ("Ver como"). Vive en sessionStorage: por pestaña y
// se pierde al cerrarla, así nadie se queda mirando por error datos ajenos.
const CLAVE = 'espacio_activo';

const leer = () => {
  try {
    const e = JSON.parse(sessionStorage.getItem(CLAVE) || 'null');
    return e && e.id && ['hogar', 'contador'].includes(e.rol) ? e : null;
  } catch { return null; }
};

export const useEspacioStore = create((set) => ({
  espacio: leer(),   // { id, rol, nombre } o null (= mi propio espacio)
  setEspacio: (espacio) => {
    try {
      if (espacio) sessionStorage.setItem(CLAVE, JSON.stringify(espacio));
      else sessionStorage.removeItem(CLAVE);
    } catch { /* sin storage: el estado en memoria basta */ }
    set({ espacio: espacio || null });
  },
}));
